import { createBrowserRouter } from "react-router";
import { AppLayout, RequireAuth } from "./layouts/AppLayout";
import { ProjectLayout } from "./layouts/ProjectLayout";
import { AccountPage } from "./pages/AccountPage";
import { AdminUsersPage } from "./pages/AdminUsersPage";
import { LoginPage, SetupPage } from "./pages/AuthPages";
import { EpicPage } from "./pages/EpicPage";
import { FilesPage } from "./pages/FilesPage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { ProjectOverviewPage } from "./pages/ProjectOverviewPage";
import { ProjectsPage } from "./pages/ProjectsPage";
import { ProjectSettingsPage } from "./pages/ProjectSettingsPage";
import { ProjectTasksPage } from "./pages/ProjectTasksPage";
import { SprintPage } from "./pages/SprintPage";
import { TaskPage } from "./pages/TaskPage";

export const router = createBrowserRouter([
  { path: "/login", element: <LoginPage /> },
  { path: "/setup", element: <SetupPage /> },
  {
    element: <RequireAuth />,
    children: [
      {
        element: <AppLayout />,
        children: [
          { index: true, element: <ProjectsPage /> },
          { path: "account", element: <AccountPage /> },
          { path: "admin/users", element: <AdminUsersPage /> },
        ],
      },
      {
        path: "p/:pid",
        element: <ProjectLayout />,
        children: [
          { index: true, element: <ProjectOverviewPage /> },
          { path: "tasks", element: <ProjectTasksPage /> },
          { path: "tasks/:tid", element: <TaskPage /> },
          { path: "epics/:eid", element: <EpicPage /> },
          { path: "sprints/:sid", element: <SprintPage /> },
          { path: "files", element: <FilesPage /> },
          { path: "settings", element: <ProjectSettingsPage /> },
        ],
      },
      { path: "*", element: <NotFoundPage /> },
    ],
  },
]);
